// src/utils/format.js

// Valuta-formatering (NOK)
export function fmtNOK(n) {
  return new Intl.NumberFormat("no-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);
}

// Dato + tid (dd.mm.yyyy HH:mm)
export function fmtDT(d) {
  const dt = d ? new Date(d) : null;
  return dt && !isNaN(+dt)
    ? dt
        .toLocaleString("no-NO", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })
        .replace(",", "")
    : "";
}

// Kun dato (dd.mm.yyyy)
export function fmtDate(d) {
  const dt = d ? new Date(d) : null;
  return dt && !isNaN(+dt)
    ? dt.toLocaleDateString("no-NO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : "";
}

// Minutter → "X t Y min" / "X t" / "Y min"
export function fmtMin(m) {
  const n = Math.max(0, Number(m) || 0);
  const h = Math.floor(n / 60);
  const r = n % 60;
  if (h && r) return `${h} t ${r} min`;
  if (h) return `${h} t`;
  return `${r} min`;
}

// Kort referanse-id (servicenummer foran)
export function toShortRefFront(raw) {
  const s = String(raw || "").trim();
  // 4–6 sammenhengende siffer?
  const m = s.match(/\b(\d{4,6})\b/);
  if (m) return m[1];
  // ellers: siste 5 siffer hvis mulig
  const digits = s.replace(/\D+/g, "");
  if (digits.length >= 5) return digits.slice(-5);
  return s.slice(-5) || "";
}

// Normalisering av norsk telefonnummer
export function normalizePhone(n) {
  if (!n) return "";

  const digits = String(n).replace(/\D/g, ""); // kun sifre

  // 8 sifre: ser ut som et vanlig norsk nummer → behold det
  if (digits.length === 8) return digits;

  // 10 sifre og starter med 47 → 47 + 8 sifre (norsk landskode)
  if (digits.length === 10 && digits.startsWith("47")) {
    return digits.slice(-8);
  }

  // 12 sifre og starter med 0047 → 0047 + 8 sifre
  if (digits.length === 12 && digits.startsWith("0047")) {
    return digits.slice(-8);
  }

  // Alt annet: ikke prøv å tolke → behold som det er (men kun sifre)
  return digits;
}

// Tekst inn i HTML som bygges som streng (utskriftsvinduer med document.write).
// Navn, adresser og kommentarer kommer fra offentlige skjemaer og må escapes (regel S4).
export function escapeHtml(verdi) {
  return String(verdi ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
